import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
  selector: 'pt-text-cell-editable-renderer',
  template: `
    <div class="fake-text">
      <div class="text">{{params.value}}</div>
    </div>
  `,
  styles: [`
    .fake-text {
      width: 100%;
      height: 100%;
      border: 1px solid #33333333;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 5px;
      background: white;
    }

    .fake-text .text {
      display: block;
      width: calc(100% - 20px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `]
})
export class TextCellEditableRendererComponent implements ICellRendererAngularComp, IHeaderAngularComp {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean;
  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }
}
